<template>
  <div>
    <h2 class="content-block">Pegawai List JS</h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          class="dx-card wide-card"
          id="dataGrid"
          :data-source="dataSource"
          key-expr="ID"
          :focused-row-index="0"
          :show-borders="true"
          :show-column-lines="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          :allow-column-reordering="true"
          @editing-start="logEvent('EditingStart')"
          @init-new-row="logEvent('InitNewRow')"
          @row-inserting="logEvent('RowInserting')"
          @row-inserted="logEvent('RowInserted')"
          @row-updating="logEvent('RowUpdating')"
          @row-updated="logEvent('RowUpdated')"
          @row-removing="logEvent('RowRemoving')"
          @row-removed="logEvent('RowRemoved')"
          @saving="logEvent('saving')"
          @saved="logEvent('Saved')"
          @edit-canceling="logEvent('EditCanceling')"
          @edit-canceled="logEvent('EditCanceled')"
          @exporting="onExporting"
          :onValidation="onValidationDataGrid"
        >
          <dx-paging :page-size="5" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <dx-filter-row :visible="true" />
          <!-- <DxSelection
            :select-all-mode="allMode"
            :show-check-boxes-mode="checkBoxesMode"
            mode="multiple"
          /> -->
          <DxEditing
            :allow-updating="true"
            :allow-deleting="true"
            :allow-adding="true"
            mode="row"
          />
          <!-- <DxEditing
            :allow-updating="true"
            :allow-deleting="true"
            :allow-adding="true"
            mode="popup"
          >
            <DxPopup
              :show-title="true"
              :width="700"
              :height="525"
              title="Employee Info"
            />
            <DxForm>
              <DxItem :col-count="2" :col-span="2" item-type="group">
                <DxItem data-field="FirstName" />
                <DxItem data-field="LastName" />
                <DxItem data-field="Prefix" />
                <DxItem data-field="BirthDate" />
                <DxItem data-field="Position" />
                <DxItem data-field="HireDate" />
                <DxItem
                  :col-span="2"
                  :editor-options="{ height: 100 }"
                  data-field="Notes"
                  editor-type="dxTextArea"
                />
              </DxItem>

              <DxItem
                :col-count="2"
                :col-span="2"
                item-type="group"
                caption="Home Address"
              >
                <DxItem data-field="StateID" />
                <DxItem data-field="Address" />
              </DxItem>
            </DxForm>
          </DxEditing>// -->
          <DxExport :enabled="true" :allow-export-selected-data="true" />
          <DxSelection mode="multiple" />
          <DxColumnFixing :enabled="true" />
          <DxToolbar>
            <DxItem name="groupPanel" />

            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
            <DxItem location="after" template="button-template" />
          </DxToolbar>
          <!-- :text="expanded ? 'Collapse All' : 'Expand All'" -->
          <template #button-template>
            <DxButton text="Import data" :width="136" @click="importClick" />
          </template>

          <dx-column
            data-field="NamaPegawai"
            caption="Pegawai"
            :fixed="true"
            fixed-position="left"
            :allow-sorting="true"
          />
          <dx-column data-field="Cabang" caption="Cabang">
            <dx-lookup
              display-expr="name"
              value-expr="value"
              :data-source="cabangs"
            />
          </dx-column>
          <dx-column data-field="Bagian" caption="Bagian" :allow-sorting="true">
            <dx-lookup
              display-expr="name"
              value-expr="value"
              :data-source="bagians"
            />
          </dx-column>
          <dx-column
            data-field="SubBagian"
            caption="Sub Bagian"
            :allow-sorting="true"
          >
            <dx-lookup
              display-expr="name"
              value-expr="value"
              :data-source="subBagians"
            />
          </dx-column>
          <dx-column
            data-field="Jabatan"
            caption="Jabatan"
            :allow-sorting="true"
          >
            <dx-lookup
              display-expr="name"
              value-expr="value"
              :data-source="jabatans"
            />
          </dx-column>
          <dx-column
            data-field="Golongan"
            caption="Golongan"
            :allow-sorting="true"
          >
            <dx-lookup
              display-expr="name"
              value-expr="value"
              :data-source="golongans"
            />
          </dx-column>
          <dx-column data-field="Status" caption="Status" :allow-sorting="true">
            <dx-lookup
              display-expr="name"
              value-expr="value"
              :data-source="statuss"
            />
          </dx-column>
          <dx-column
            data-field="TglMasuk"
            caption="Tgl Masuk"
            data-type="date"
            :format="'dd/MM/yyyy'"
            :allow-sorting="true"
          />
          <dx-column
            data-field="TglKeluar"
            caption="Tgl Keluar"
            data-type="date"
            :format="'dd/MM/yyyy'"
            :allow-sorting="true"
          />
          <dx-column
            data-field="TglPensiun"
            caption="Tgl Pensiun"
            data-type="date"
            :format="'dd/MM/yyyy'"
            :allow-sorting="true"
          />
          <dx-column
            data-field="TempatLahir"
            caption="Tempat Lahir"
            :allow-sorting="true"
          />
          <dx-column
            data-field="TglLahir"
            caption="Tgl Lahir"
            :allow-sorting="true"
            data-type="date"
            :format="'dd/MM/yyyy'"
          />
          <dx-column data-field="Telp" caption="Telp" :allow-sorting="true" />
          <dx-column
            data-field="Alamat"
            caption="Alamat"
            :allow-sorting="true"
          />
          <dx-column data-field="Agama" caption="Agama" :allow-sorting="true">
            <dx-lookup
              display-expr="name"
              value-expr="value"
              :data-source="agamas"
            />
          </dx-column>
          <dx-column
            data-field="JenisKelamin"
            caption="Jenis Kelamin"
            :allow-sorting="true"
          />
          <dx-column
            data-field="StatusPerkawinan"
            caption="Status Perkawinan"
          />
          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="ID"
            caption=" "
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxPaging,
  // DxEditing,
  DxColumnFixing,
  DxExport,
  DxSelection,
  // DxButton,
  DxToolbar,
  DxItem,
  DxEditing,
  // DxPopup,
  // DxForm,
} from "devextreme-vue/data-grid";
import notify from "devextreme/ui/notify";
import DxDropDownButton from "devextreme-vue/drop-down-button";
// eslint-disable-next-line
import router from "@/router";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { DxButton } from "devextreme-vue/button";
// import { pegawais } from "@/store/dataPegawai.js";
import { pegawais } from "./dataPegawai.js";
const cabangs = [
  { name: "Pusat", value: "Pusat" },
  { name: "Lovina", value: "Lovina" },
  { name: "Seririt", value: "Seririt" },
  { name: "Pancasari", value: "Pancasari" },
  { name: "Gerokgak", value: "Gerokgak" },
  { name: "Busungbiu", value: "Busungbiu" },
  { name: "tambah", value: "tambah" },
];

const bagians = [
  { name: "Litbang", value: "Litbang" },
  { name: "Produksi", value: "Produksi" },
  { name: "Distribusi", value: "Distribusi" },
  { name: "Akuntansi", value: "Akuntansi" },
  { name: "Keuangan", value: "Keuangan" },
  { name: "Personalia", value: "Personalia" },
];

const subBagians = [{ name: "TI", value: "TI" }];

const jabatans = [
  { name: "Kabag", value: "Kabag" },
  { name: "Kasubag", value: "Kasubag" },
  { name: "Staf", value: "Staf" },
  { name: "Direktur Utama", value: "Direktur Utama" },
];

const golongans = [
  { name: "A1", value: "A1" },
  { name: "B1", value: "B1" },
  { name: "C1", value: "C1" },
];

const statuss = [
  { name: "Pegawai Tetap", value: "Pegawai Tetap" },
  { name: "Calon Pegawai", value: "Calon Pegawai" },
  { name: "Kontrak", value: "Kontrak" },
  { name: "Training", value: "Training" },
];

const agamas = [
  { name: "Hindu", value: "Hindu" },
  { name: "Islam", value: "Islam" },
  { name: "Buddha", value: "Buddha" },
];

const options = ["Detail", "Transfer", "Resign", "Delete"];

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxPaging,
    DxEditing,
    // DxPopup,
    // DxForm,
    DxColumnFixing,
    // DxButton,
    DxDropDownButton,
    DxExport,
    DxSelection,
    DxToolbar,
    DxItem,
    DxButton,
  },
  data() {
    return {
      events: [],
      dataSource: pegawais,
      // cities: cities,
      cabangs: cabangs,
      bagians: bagians,
      subBagians: subBagians,
      jabatan: jabatans,
      golongans: golongans,
      statuss: statuss,
      agamas: agamas,
      options: options,
      router: router,
    };
  },
  methods: {
    onValidationDataGrid(e) {
      console.log(e);
    },
    importClick() {
      this.router.push({
        name: "practice-sheetjs",
        query: { table: "pegawai" },
      });
    },
    logEvent(eventName) {
      this.events.unshift(eventName);
    },
    clearEvents() {
      this.events = [];
    },

    onSaving(e) {
      console.log(e);
    },
    myCommand(e) {
      console.log(e);
      alert("command");
    },
    onItemClick(e) {
      console.log(e.element.id);
      let pegawaiId = e.element.id;
      notify(e.itemData.name || e.itemData, "success", 600);
      this.router.push({ name: "tab-treeview", query: { id: pegawaiId } }); //?id=1
      // this.router.push({ name: "tab-treeview", params: { id: pegawaiId } }); //id tak terlihat di url
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Sheet 1");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Pegawai.xlsx"
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>

<style>
.text-center {
  text-align: center;
}
</style>
